import { useQuery } from "@tanstack/react-query";
import API from "@/api";

function useTanks(nurseryId: string, enabled: boolean = true) {
  const { isPending, error, data } = useQuery({
    queryKey: ["tanks", nurseryId],
    queryFn: () => API.getTanks(nurseryId),
    enabled
  });

  return {
    isPending,
    error,
    data
  };
}

export default useTanks;
